/* Storefront discovery measurement only. Checkout/revenue requires a separate verified connection. */
(() => {
  'use strict';
  const element = document.currentScript;
  const id = element?.dataset.measurementId;
  const status = value => { if (element) element.dataset.qoolalaAnalyticsStatus = value; };
  if (!/^G-[A-Z0-9]+$/.test(id || '') || window.__qoolalaAnalytics) return;
  window.__qoolalaAnalytics = true;
  const page = new URL(window.location.href);
  if (page.hostname !== 'qoolala.com' || window.Shopify?.designMode ||
      window.Shopify?.theme?.role !== 'main' ||
      ['preview_theme_id', 'preview_key', '_fd', 'pb'].some(key => page.searchParams.has(key))) {
    status('preview_or_nonproduction');
    return;
  }
  if (!/^\/(?:$|pages\/|products\/|collections(?:\/|$)|blogs\/)/.test(page.pathname)) {
    status('nonpublic_route');
    return;
  }
  if (typeof window.gtag === 'function' || document.querySelector('script[src*="googletagmanager.com/"]')) {
    status('existing_google_tag');
    return;
  }
  let loaded = false;
  let allowed = false;
  const disableKey = 'ga-disable-' + id;
  window[disableKey] = true;
  const command = function () { window.dataLayer.push(arguments); };
  const cleanUrl = (value, campaign) => {
    try {
      const url = new URL(value);
      const clean = new URL(url.origin + url.pathname);
      if (campaign) ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_content', 'utm_term'].forEach(key => {
        const value = url.searchParams.get(key);
        if (value && value.length <= 120 && !value.includes('@')) clean.searchParams.set(key, value);
      });
      return clean.href;
    } catch (_) { return ''; }
  };
  const consent = value => ({analytics_storage: value, ad_storage: 'denied',
    ad_user_data: 'denied', ad_personalization: 'denied'});
  const reconcile = () => {
    const privacy = window.Shopify?.customerPrivacy;
    // Explicit analytics consent as well as Shopify's regional processing decision.
    const next = !!(privacy && privacy.analyticsProcessingAllowed() &&
      privacy.currentVisitorConsent().analytics === 'yes');
    allowed = next;
    window[disableKey] = !next;
    if (!next) {
      if (loaded) command('consent', 'update', consent('denied'));
      status('awaiting_consent');
      return;
    }
    if (loaded) {
      command('consent', 'update', consent('granted'));
      status('enabled');
      return;
    }
    loaded = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = command;
    command('consent', 'default', consent('denied'));
    command('consent', 'update', consent('granted'));
    command('js', new Date());
    const location = cleanUrl(page.href, true);
    command('config', id, {send_page_view: false, page_location: location,
      page_referrer: cleanUrl(document.referrer, false),
      allow_google_signals: false, allow_ad_personalization_signals: false});
    command('event', 'page_view', {send_to: id, page_location: location,
      page_referrer: cleanUrl(document.referrer, false), page_title: document.title});
    const tag = document.createElement('script');
    tag.async = true;
    tag.src = 'https://www.googletagmanager.com/gtag/js?id=' + id;
    tag.onerror = () => status('tag_load_failed');
    document.head.appendChild(tag);
    status('enabled');
  };
  document.addEventListener('visitorConsentCollected', () => {
    try { reconcile(); } catch (_) { allowed = false; window[disableKey] = true; status('privacy_unavailable'); }
  });
  // No chat text, voice transcript, email, cart contents or customer identifiers.
  document.addEventListener('click', event => {
    if (!allowed || !loaded) return;
    const link = event.target.closest?.('a[target="_blank"]');
    const card = link?.closest('[data-qg-kind="external"]');
    if (!card) return;
    const category = card.dataset.category;
    if (!['PHONE', 'DESK', 'TRAVEL'].includes(category)) return;
    const type = link.dataset?.qoolalaLink || 'source';
    const name = {source: 'qoolala_source_open', affiliate: 'qoolala_affiliate_open', maker: 'qoolala_maker_open'}[type];
    if (!name) return;
    command('event', name, {send_to: id, content_group: category,
      item_id: card.dataset.discoveryHandle});
  });
  document.addEventListener('qoolala:engagement', event => {
    if (!allowed || !loaded) return;
    const {action, category, item_id} = event.detail || {};
    if (!['save', 'unsave', 'share'].includes(action) || !['PHONE', 'DESK', 'TRAVEL'].includes(category)) return;
    if (typeof item_id !== 'string' || !/^[a-zA-Z0-9_-]{1,150}$/.test(item_id)) return;
    command('event', 'qoolala_' + action, {send_to: id, content_group: category, item_id});
  });
  status('awaiting_consent');
  try {
    if (window.Shopify?.customerPrivacy) reconcile();
    else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([
      {name: 'consent-tracking-api', version: '0.2'}
    ], error => {
      try { if (error) status('privacy_unavailable'); else reconcile(); }
      catch (_) { status('privacy_unavailable'); }
    });
    else status('privacy_unavailable');
  } catch (_) { status('privacy_unavailable'); }
})();
